import { render, staticRenderFns } from "./left3.vue?vue&type=template&id=134eecb5&scoped=true&"
import script from "./left3.vue?vue&type=script&lang=js&"
export * from "./left3.vue?vue&type=script&lang=js&"
import style0 from "./left3.vue?vue&type=style&index=0&id=134eecb5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134eecb5",
  null
  
)

export default component.exports